import React, { useRef, useState } from 'react'
import { withApollo, compose } from 'react-apollo'
import { useDispatch, useSelector } from 'react-redux'
import {
  Card,
  Table,
  Button,
  Row, Col,
  Divider,
  Popconfirm
} from 'antd'
import {
  fetchCategories,
  updateCategory,
  createSubCategory,
  updateSubCategory,
  deleteSubCategory
} from '../../modules/equipment'
import { useDeepEffect } from '../../utils/hooks'
import _, { isEmpty } from 'lodash'
import CategoryEquipmentForm from './components/CategoryEquipment'
import SubEquipmentCategoryForm from './components/SubEquipmentCategoryForm'
import axios from 'axios'

const CategoryEquipment = () => {
  const dispatch = useDispatch()
  const [visible, setVisible] = useState(false)
  const [visibleSubCategory, setVisibleSubCategory] = useState(false)
  const [formData, setFormData] = useState({})
  const [formSubCategory, setFormSubCategory] = useState({})


  const { categories, isLoading } = useSelector(
    (state) => ({
      categories: state.equipment.categories.data,
      isLoading: state.equipment.isLoading
    }),
    []
  )

  useDeepEffect(() => {
    async function fetch() {
      await dispatch(fetchCategories())
    }
    fetch()
  }, [])

  const onClick = (e, record) => {
    e.preventDefault()
    setVisible(true)
    setFormData(record)
  }
  const onCloseModal = async () => {
    await dispatch(fetchCategories())
    await setVisible(false)
  }

  const onOk = async (data) => {
    if (!_.isEmpty(formData)) {
      await dispatch(updateCategory(data))
    }
    await dispatch(fetchCategories())
    await setVisible(false)
    await setFormData({})
  }

  async function onCickSubCategory(e, record) {
    e.preventDefault()
    setVisibleSubCategory(true)
    setFormSubCategory(record)
  }

  const onCloseSubModal = async () => {
    await dispatch(fetchCategories())
    await setVisibleSubCategory(false)
  }

  const onSubOk = async (data) => {
    if (!_.isEmpty(formSubCategory)) {
      await dispatch(updateSubCategory(data))
    } else {
      await dispatch(createSubCategory(data))
    }
    await dispatch(fetchCategories())
    await setVisibleSubCategory(false)
    await setFormSubCategory({})
  }

  const onSubDelete = async (id) => {
    await dispatch(deleteSubCategory(id))
    await dispatch(fetchCategories())
  }

  const HeaderSubCategory = () => {
    return (
      <Row type="flex" justify="space-between">
        <Col>
          <span>Equipment Category</span>
        </Col>
        <Col>
          <Button
            type="primary"
            onClick={(e) => onCickSubCategory(e)}>
            Add Sub Category
          </Button>
        </Col>
      </Row>
    )
  }

  const columns = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      render: (name, row) => (
        <div>
          {row.image && (
            <img
              src={row.image}
              width={64}
              height={64}
              style={{ marginRight: 10, objectFit: 'cover' }}
            />
          )}
          {name}
        </div>
      )
    },
    {
      title: 'Action',
      key: 'action',
      render: (text, record) => (
        <span>
          <Button
            type="primary"
            size="small"
            shape="circle"
            icon="edit"
            onClick={(e) => {
              onClick(e, record)
            }}
          />
        </span>
      )
    }
  ]

  const subColumns = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      render: (name, row) => (
        <div>
          {row.image && (
            <img
              src={row.image}
              width={64}
              height={64}
              style={{ marginRight: 10, objectFit: 'cover' }}
            />
          )}
          {name}
        </div>
      )
    },
    {
      title: 'Action',
      key: 'action',
      render: (text, record) => (
        <span>
          <Button
            type="primary"
            size="small"
            shape="circle"
            icon="edit"
            onClick={(e) => {
              onCickSubCategory(e, record)
            }}
          />
          <Divider type="vertical" />
          <Popconfirm
            title="Sure to delete?"
            onConfirm={() => onSubDelete(record.id)}
          >
            <Button
              type="danger"
              size="small"
              shape="circle"
              icon="delete"
            />
          </Popconfirm>
        </span>
      )
    }
  ]

  return (
    <Card title={HeaderSubCategory()}>
      <Table
        loading={isLoading}
        rowKey={(record) => record.id}
        bordered
        dataSource={categories}
        columns={columns}
        expandedRowRender={(record) => (
          <Card>
            <Table
              loading={isLoading}
              bordered
              dataSource={record.subEquipmentList}
              columns={subColumns}
            />
          </Card>
        )}
      />
      <CategoryEquipmentForm
        visible={visible}
        onOk={onOk}
        onCancel={onCloseModal}
        formData={formData}
      />
      <SubEquipmentCategoryForm
        visible={visibleSubCategory}
        onOk={onSubOk}
        onCancel={onCloseSubModal}
        formData={formSubCategory}
      />
    </Card>
  )
}

export default compose(
  withApollo
)(CategoryEquipment)